export const CATEGORIES = [
    'Computer',
    'Console',
    'Peripheral',
    'Software',
    'Documentation',
    'Media',
    'Component',
    'Accessory',
    'Other',
];
export const PLATFORMS = [
    '3DO',
    'Acorn',
    'Amstrad',
    'Apple',
    'Atari',
    'Commodore',
    'Compaq',
    'Digital Equipment Corporation',
    'IBM PC',
    'MSX',
    'NEC',
    'Neo Geo',
    'Nintendo',
    'Sega',
    'Silicon Graphics',
    'Sinclair',
    'SNK',
    'Sony',
    'Sun',
    'Tandy',
    'TI',
    'Other',
];
export const CONDITIONS = [
    'mint',
    'excellent',
    'good',
    'fair',
    'poor',
    'parts',
];
export const CURRENCIES = ['AUD', 'CAD', 'CHF', 'EUR', 'GBP', 'ILS', 'JPY', 'SEK', 'USD'];
export const VIDEO_SYSTEMS = ['PAL', 'NTSC', 'SECAM', 'Dual', 'Other'];
/** Platforms valid per category. Categories not listed here fall back to full PLATFORMS list. */
export const CATEGORY_PLATFORMS = {
    Computer: ['Acorn', 'Amstrad', 'Apple', 'Atari', 'Commodore', 'Compaq', 'Digital Equipment Corporation', 'IBM PC', 'MSX', 'NEC', 'Silicon Graphics', 'Sinclair', 'Sun', 'Tandy', 'TI', 'Other'],
    Console: ['3DO', 'Atari', 'Commodore', 'NEC', 'Neo Geo', 'Nintendo', 'Sega', 'SNK', 'Sony', 'Other'],
};
/** Default subcategory suggestions keyed by category. */
export const DEFAULT_SUBCATEGORIES = {
    Computer: ['Desktop', 'Laptop', 'Portable', 'Single Board', 'Kit'],
    Console: ['Home Console', 'Handheld', 'Micro Console', 'Pong Clone'],
    Peripheral: ['Graphics Card', 'Sound Card', 'Memory', 'Disk Drive', 'Controller', 'Joystick', 'Mouse', 'Keyboard', 'Modem', 'Network Card', 'Printer', 'Monitor', 'Scanner'],
    Software: ['Game', 'Application', 'Operating System', 'Development Tool', 'Demo', 'Utility'],
    Documentation: ['Manual', 'Magazine', 'Book', 'Poster', 'Map', 'Reference Card'],
    Media: ['Floppy Disk', 'Cartridge', 'Cassette Tape', 'CD-ROM', 'Laserdisc'],
    Component: ['CPU', 'RAM', 'ROM', 'Capacitor', 'IC Chip', 'Power Supply', 'Transformer', 'Crystal Oscillator'],
    Accessory: ['Case', 'Cover', 'Cable', 'Adapter', 'Carrying Bag', 'Stand'],
    Other: [],
};
/** Platform model suggestions keyed by platform. */
export const PLATFORM_MODELS = {
    Commodore: ['Amiga 500', 'Amiga 1200', 'Amiga 2000', 'Amiga 4000', 'C64', 'C128', 'VIC-20', 'Plus/4', 'PET', 'CDTV', 'CD32'],
    Compaq: ['Portable', 'Deskpro', 'Deskpro 386', 'Presario', 'ProLiant', 'AlphaServer'],
    'Digital Equipment Corporation': ['PDP-8', 'PDP-11', 'VAX-11/780', 'VAXstation', 'DECstation', 'AlphaStation', 'Alpha'],
    Atari: ['2600', '5200', '7800', '400', '800', '800XL', '130XE', 'ST', 'STE', 'Falcon', 'Jaguar', 'Lynx'],
    Sinclair: ['ZX Spectrum', 'ZX Spectrum 128', 'ZX Spectrum +2', 'ZX Spectrum +3', 'ZX81', 'QL'],
    Apple: ['Apple II', 'Apple IIe', 'Apple IIgs', 'Macintosh 128K', 'Macintosh SE', 'Macintosh Classic', 'PowerBook', 'iMac G3', 'Power Mac G3', 'Newton'],
    Nintendo: ['NES', 'SNES', 'N64', 'GameCube', 'Game Boy', 'Game Boy Color', 'Game Boy Advance', 'Virtual Boy'],
    Sega: ['Master System', 'Genesis', 'Mega Drive', 'Saturn', 'Dreamcast', 'Game Gear', 'SG-1000'],
    'Silicon Graphics': ['Indy', 'Indigo', 'Indigo2', 'O2', 'Octane', 'Onyx', 'Origin 200'],
    Sony: ['PlayStation', 'PS One', 'PS2', 'PSP'],
    Sun: ['SPARCstation', 'Ultra 5', 'Ultra 10', 'Ultra 60', 'Blade 100', 'Enterprise 450', 'Netra'],
    NEC: ['PC Engine', 'TurboGrafx-16', 'PC-FX', 'PC-8801', 'PC-9801'],
    SNK: ['Neo Geo AES', 'Neo Geo MVS', 'Neo Geo CD', 'Neo Geo Pocket', 'Neo Geo Pocket Color'],
    Acorn: ['BBC Micro', 'BBC Master', 'Archimedes', 'Electron', 'Atom'],
    Amstrad: ['CPC 464', 'CPC 6128', 'PCW 8256', 'GX4000'],
    MSX: ['MSX', 'MSX2', 'MSX2+', 'MSX turbo R'],
    Tandy: ['TRS-80', 'TRS-80 Model III', 'TRS-80 Color Computer', 'Model 100'],
    '3DO': ['3DO FZ-1', '3DO FZ-10', 'Goldstar 3DO'],
    'IBM PC': ['IBM PC 5150', 'IBM PC/AT', 'IBM PS/2', 'Clone'],
    TI: ['TI-99/4A'],
    'Neo Geo': ['AES', 'MVS', 'CD', 'Pocket'],
};
//# sourceMappingURL=inventory.js.map